import { useEffect } from 'react';

import { useForm } from 'react-hook-form';

import { useAppSelector } from 'src/app/store/hooks';
import type { RootState } from 'src/app/store/types';

import { assignDefaultFormValues } from './assignDefaultFormValues';
import { getStepTitle } from './getStepTitle';
import { useAttendantFormStepTwoSubmission } from './useAttendantFormStepTwoSubmission';

export function useAttendantProfileFormViewModel() {
  const open = useAppSelector(
    (state: RootState) => state.team.showAttendantProfileModal
  );
  const selectedAttendantProfile = useAppSelector(
    (state: RootState) => state.team.selectedAttendantProfile
  );
  const selectedMemberProfile = useAppSelector(
    (state) => state.team.selectedMemberProfile
  );

  const defaultFormValues = assignDefaultFormValues(selectedAttendantProfile);
  const canPreselectedProfile =
    selectedMemberProfile && !selectedAttendantProfile?.id;
  // Preselect member when transitioning from post-member create modal
  if (canPreselectedProfile) {
    defaultFormValues.membership = selectedMemberProfile.id;
  }

  const methods = useForm({
    defaultValues: defaultFormValues,
  });
  const {
    onSubmitStepTwo,
    isSubmitting,
    setStep,
    setServerErrors,
    serverErrors,
    step,
  } = useAttendantFormStepTwoSubmission({
    methods,
    skipStepOne: !!canPreselectedProfile,
  });

  const title = getStepTitle(step, selectedAttendantProfile);

  useEffect(() => {
    if (open) {
      methods.reset(defaultFormValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return {
    open,
    setStep,
    setServerErrors,
    step,
    methods,
    title,
    selectedAttendantProfile,
    onSubmitStepTwo,
    isSubmitting,
    serverErrors,
  };
}
